module.exports = __webpack_public_path__ + "cb1c9d825190668144c6ad7e56628851.svg";